import { LocaleCode, negotiateLocale } from "../i18n/localeRegistry";
import { MARKETING_LANGUAGES, MARKETING_LOCALES, MarketingLanguage } from "./marketingLocales";
import { getMarketingPageLanguage, getMarketingPageTranslations } from "./marketingPageTranslations";

const CHOICE_KEY = "jungle.marketing.language-choice.v1";
export const MARKETING_LANGUAGE_CHOICE_EVENT = "jungle-marketing-language-choice";
// Session storage can be unavailable. Keep an in-document choice authoritative in that case too.
let choiceMade = false;

export function hasMarketingLanguageChoice(): boolean {
  if (choiceMade) return true;
  try { return window.sessionStorage.getItem(CHOICE_KEY) === "1"; } catch { return false; }
}

export function rememberMarketingLanguageChoice(): void {
  choiceMade = true;
  try { window.sessionStorage.setItem(CHOICE_KEY, "1"); } catch { /* The current document still remembers. */ }
  window.dispatchEvent(new Event(MARKETING_LANGUAGE_CHOICE_EVENT));
}

/** Suggest an actual counterpart of an English page; a registered/draft edition is never enough. */
export function getMarketingLanguageSuggestion(pathname: string, preferences: readonly string[]): { language: MarketingLanguage; href: string } | null {
  if (getMarketingPageLanguage(pathname) !== "en") return null;
  const translations = getMarketingPageTranslations(pathname);
  const available = MARKETING_LANGUAGES.filter(language => translations[language]);
  const selected = negotiateLocale(preferences, available.map(language => MARKETING_LOCALES[language].productLocale as LocaleCode));
  const language = available.find(candidate => MARKETING_LOCALES[candidate].productLocale === selected);
  const href = language && translations[language];
  return language && language !== "en" && href ? { language, href } : null;
}
